// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   Global Responsive Rem Scaling
   All rem-based measurements will scale proportionally
   based on screen size for consistent responsive design
   ======================================== */
html {
  font-size: 16px; /* Default: 1rem = 16px for large screens */
}
@media (max-width: 1400px) {
  html {
    font-size: 15px; /* 1rem = 15px, scales everything to 93.75% */
  }
}
@media (max-width: 1200px) {
  html {
    font-size: 14px; /* 1rem = 14px, scales everything to 87.5% */
  }
}
@media (max-width: 968px) {
  html {
    font-size: 13px; /* 1rem = 13px, scales everything to 81.25% */
  }
}
@media (max-width: 576px) {
  html {
    font-size: 12px; /* 1rem = 12px, scales everything to 75% */
  }
}
/* ========================================
   Layout Body Styles
   ======================================== */
.custom-body {
  padding: 0;
  height: calc(100vh - 3.5rem);
  overflow-y: auto;
}
/* Focus mode hides the global app header — give .custom-body the full viewport height */
body.report-focus-mode .custom-body {
  height: 100vh;
}
.viewer-body {
  /* padding: 0 0.75rem; */
  /* height: calc(100% - 60px); */
  overflow-y: auto;
}
.login-body {
  padding: 0;
  height: 100vh;
  overflow: hidden;
}
.no-auth-body {
  padding: 0;
  height: 100vh;
  overflow-y: auto;
}
/* Pill-style segmented control tabs */
.ant-tabs-nav {
  margin: 0;
  padding: 1rem 1.25rem;
  background: #F5F7FD;
  border-bottom: none;
}
.ant-tabs-nav-wrap {
  padding: 0;
}
.ant-tabs-nav-list {
  background: #FFFFFF;
  border-radius: 0.625rem;
  padding: 0.25rem;
  gap: 0.625rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: -moz-fit-content;
  width: -webkit-fit-content;
  width: fit-content;
  height: 2.5rem;
}
.ant-tabs-tab {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent;
  border: none;
  border-radius: 0.5rem;
  height: 2rem;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.ant-tabs-tab-btn {
  padding: 0.375rem 1rem;
  font-family: 'Inter Variable', Inter, sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.04px;
  color: #000000;
  background: #FFFFFF;
  border-radius: 0.5rem;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  height: 2rem;
  white-space: nowrap;
}
/* Inactive tab hover state */
.ant-tabs-tab:not(.ant-tabs-tab-active):hover .ant-tabs-tab-btn {
  background: #e8e8e8;
  color: #333333;
}
/* Active tab state */
.ant-tabs-tab.ant-tabs-tab-active {
  background: transparent;
}
/* Use higher specificity to override Ant Design's internal styles */
.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  background: var(--primary-color) !important;
  color: #ffffff !important;
  font-weight: 600;
  text-shadow: none !important;
}
/* Hide the default ink bar */
.ant-tabs-ink-bar {
  display: none;
}
/* Content styling */
.ant-tabs-content-holder {
  background: #F5F7FD;
}
.ant-tabs-tabpane {
  padding: 0;
}
/* Remove default Ant Design tab borders and spacing */
.ant-tabs > .ant-tabs-nav {
  border-bottom: none;
  background: #F5F7FD;
}
/* Override Ant Design's default 16px bottom margin */
.ant-tabs-top > .ant-tabs-nav,
.ant-tabs-bottom > .ant-tabs-nav,
.ant-tabs-top > div > .ant-tabs-nav,
.ant-tabs-bottom > div > .ant-tabs-nav {
  margin: 0 !important;
}
/* Remove default icon margin in tabs */
.ant-tabs .ant-tabs-tab .anticon:not(:last-child) {
  margin-right: 0 !important;
}
/* Icon styling in tab buttons */
.ant-tabs-tab-btn .anticon {
  font-weight: normal !important;
}
.ant-tabs-tab + .ant-tabs-tab {
  margin-left: 0;
}
/* Reusable Button Styles */
/* Secondary Button Style */
.btn-secondary {
  padding: 0.375rem 0.625rem;
  height: 2.25rem;
  background: #FFFFFF;
  border: 1px solid #EAEEF2;
  -webkit-box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;
          box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;
  border-radius: 0.375rem;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.04px;
  color: #000000;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.btn-secondary:hover {
  background: #f8f9fa;
  border-color: #d1d5db;
}
/* Primary Button Style */
.btn-primary {
  padding: 0.375rem 0.625rem;
  height: 2.25rem;
  background: #7D48B0;
  border: 1px solid #7D48B0;
  border-radius: 0.375rem;
  font-family: 'Inter Variable', Inter, sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.04px;
  color: #FFFFFF;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 0.375rem;
}
.btn-primary:hover {
  background: #6a3d96;
  border-color: #6a3d96;
}
/* Primary Button Disabled State */
.btn-primary:disabled,
.btn-primary[disabled] {
  background: #E5E7EB;
  border-color: #E5E7EB;
  color: #9CA3AF;
  cursor: not-allowed;
  opacity: 0.6;
}
.btn-primary:disabled:hover,
.btn-primary[disabled]:hover {
  background: #E5E7EB;
  border-color: #E5E7EB;
  color: #9CA3AF;
}
.btn-primary .anticon {
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
}
/* Compact variant — used when buttons share a line with filters/toolbars.
   Height matches the 30px "Saved views" pill so the row stays aligned. */
.btn-compact {
  height: 1.875rem;
  padding: 0.25rem 0.75rem;
  font-size: 0.8125rem;
}
/* Filters toolbar — keeps quick filters / grid on one side and the action
   buttons on the other, on a single line. Shared by Orders, My worklist and
   QC Workstation so the filter actions no longer need a dedicated tall row. */
.filter-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 0.5rem 1rem;
  margin-bottom: 1rem;
  /* Keep the chip column and the action column side-by-side; chips wrap inside
     their own column rather than pushing the action buttons to a new line. */
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
}
.filter-toolbar-main {
  /* Take only the space left of the action buttons, and allow shrinking so the
     chips wrap within this column instead of overflowing into the actions. */
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-width: 0;
}
/* Shortcut chips wrap onto multiple lines instead of overflowing the row. */
.filter-toolbar-main > div {
  margin-bottom: 0 !important;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
/* Action buttons keep their width and stay right-aligned on the first line. */
.filter-toolbar-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 0.5rem;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-left: auto;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
/* ===== Filter layout — 70 / 30 split (inputs left, modalities right) ===== */
.filter-layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 1rem;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  margin-top: 0.75rem;
}
.filter-layout-inputs {
  -webkit-box-flex: 7;
      -ms-flex: 7;
          flex: 7;
  min-width: 0;
  margin-top: 0 !important;
}
.filter-layout-modalities {
  -webkit-box-flex: 3;
      -ms-flex: 3;
          flex: 3;
  min-width: 0;
  border-left: 1px solid #E2E8F1;
  padding-left: 0.875rem;
}
.filter-modalities-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 0.375rem;
}
.filter-modalities-label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.filter-modalities-selectall.ant-checkbox-wrapper {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  -webkit-margin-start: 0 !important;
          margin-inline-start: 0 !important;
}
.filter-layout-modalities .ant-checkbox-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 0.25rem 0.75rem;
}
.filter-layout-modalities .ant-checkbox-wrapper {
  font-size: 0.8125rem;
  color: #374151;
  -webkit-margin-start: 0 !important;
          margin-inline-start: 0 !important;
}
/* Global Table Styling */
.ant-table-wrapper {
  border: 1px solid #E2E8F1;
  -webkit-box-shadow: 0rem 0rem 1.25rem 0rem #12344D40;
          box-shadow: 0rem 0rem 1.25rem 0rem #12344D40;
  border-radius: 0.5rem;
  overflow: hidden;
}
/* Global Table Header Styling */
.ant-table-thead > tr > th {
  height: 2.5rem !important;
  padding: 0.5rem 0.75rem !important;
  font-family: Inter, sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  line-height: 1.25rem !important;
  letter-spacing: 0.06px !important;
  border-bottom: none !important;
}
.ant-table-thead > tr > th::before {
  display: none !important;
}
/* Global Table Cell Typography */
.ant-table-tbody > tr > td {
  font-family: Inter, sans-serif !important;
  font-weight: 400 !important;
  font-size: 0.875rem !important;
  line-height: 1rem !important;
  letter-spacing: 0.04px !important;
}
/* Bold styling for clickable elements like patient names */
.ant-table-tbody > tr > td .col-pat-name,
.ant-table-tbody > tr > td .ant-btn-link {
  font-weight: 600 !important;
}
/* Global Table Row Styling - Alternating Colors */
.ant-table-tbody > tr:nth-child(odd) > td {
  background: #F8F5FB !important;
  border-right: 1px solid #EAEEF2 !important;
}
.ant-table-tbody > tr:nth-child(even) > td {
  background: #FFFFFF !important;
  border-right: 1px solid #EAEEF2 !important;
}
/* Remove the default Ant Design striped styling if present */
.ant-table-tbody > tr.ant-table-row:hover > td {
  background: rgba(0, 0, 0, 0.04) !important;
}
/* Ensure selected rows maintain their selection styling */
.ant-table-tbody > tr.ant-table-row-selected > td {
  background: #e6f7ff !important;
}
/* Sticky Column Fix - Remove transparency and ensure proper background */
.ant-table-tbody > tr:nth-child(odd) > td.ant-table-cell-fix-right {
  background: #F8F5FB !important;
  border-right: 1px solid #EAEEF2 !important;
  opacity: 1 !important;
}
.ant-table-tbody > tr:nth-child(even) > td.ant-table-cell-fix-right {
  background: #FFFFFF !important;
  border-right: 1px solid #EAEEF2 !important;
  opacity: 1 !important;
}
/* Sticky header cells */
.ant-table-thead > tr > th.ant-table-cell-fix-right {
  opacity: 1 !important;
  z-index: 3 !important;
}
/* Add shadow only to the first sticky column for better visual separation */
.first-sticky-column {
  -webkit-box-shadow: -0.125rem 0 0.5rem rgba(0, 0, 0, 0.1) !important;
          box-shadow: -0.125rem 0 0.5rem rgba(0, 0, 0, 0.1) !important;
}
/* Ensure shadow is applied to both header and body cells of first sticky column */
.ant-table-thead .first-sticky-column,
.ant-table-tbody .first-sticky-column {
  -webkit-box-shadow: -0.125rem 0 0.5rem rgba(0, 0, 0, 0.1) !important;
          box-shadow: -0.125rem 0 0.5rem rgba(0, 0, 0, 0.1) !important;
}
/* ========================================
   Custom Pagination Styling
   ======================================== */
/* Pagination container */
.ant-pagination {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
  -webkit-box-pack: justify !important;
      -ms-flex-pack: justify !important;
          justify-content: space-between !important;
  padding: 4px 1rem !important;
  background: #FFFFFF !important;
  border-radius: 0 0 0.75rem 0.75rem !important;
  border: 1px solid #E2E8F1 !important;
  border-top: none !important;
  margin: 0 !important;
  font-family: Inter, sans-serif !important;
}
/* Total items text */
.ant-pagination-total-text {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  color: #374151 !important;
  -webkit-box-ordinal-group: 0 !important;
      -ms-flex-order: -1 !important;
          order: -1 !important;
  margin-right: auto !important;
}
/* Page size selector */
.ant-pagination-options {
  -webkit-box-ordinal-group: 3 !important;
      -ms-flex-order: 2 !important;
          order: 2 !important;
}
.ant-pagination .ant-select {
  margin-right: 0.5rem !important;
}
.ant-pagination .ant-select-selector {
  border: 1px solid #D1D5DB !important;
  border-radius: 0.5rem !important;
  padding: 0.25rem 0.75rem !important;
  height: 2rem !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  color: #374151 !important;
  background: #FFFFFF !important;
  -webkit-transition: all 0.2s ease !important;
  transition: all 0.2s ease !important;
}
.ant-pagination .ant-select-selector:hover {
  border-color: #7D48B0 !important;
  background: #F9FAFB !important;
}
.ant-pagination .ant-select-focused .ant-select-selector {
  border-color: #7D48B0 !important;
  -webkit-box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1) !important;
          box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1) !important;
}
/* Pagination items container */
.ant-pagination-item,
.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  border: 1px solid #D1D5DB !important;
  border-radius: 0.5rem !important;
  background: #FFFFFF !important;
  min-width: 2rem !important;
  height: 2rem !important;
  line-height: 1.875rem !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  margin: 0 0.25rem !important;
  -webkit-transition: all 0.2s ease !important;
  transition: all 0.2s ease !important;
}
/* Pagination item text */
.ant-pagination-item a {
  color: #374151 !important;
  font-weight: 500 !important;
  -webkit-transition: color 0.2s ease !important;
  transition: color 0.2s ease !important;
}
/* Hover state */
.ant-pagination-item:hover,
.ant-pagination-prev:hover,
.ant-pagination-next:hover {
  border-color: #7D48B0 !important;
  background: #F7EFFF !important;
}
.ant-pagination-item:hover a {
  color: #7D48B0 !important;
}
/* Active page */
.ant-pagination-item-active {
  background: #7D48B0 !important;
  border-color: #7D48B0 !important;
}
.ant-pagination-item-active a {
  color: #FFFFFF !important;
}
.ant-pagination-item-active:hover {
  background: #7D48B0 !important;
  border-color: #7D48B0 !important;
}
.ant-pagination-item-active:hover a {
  color: #FFFFFF !important;
}
/* Disabled state */
.ant-pagination-disabled,
.ant-pagination-disabled:hover {
  border-color: #E5E7EB !important;
  background: #F9FAFB !important;
  cursor: not-allowed !important;
}
.ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination-disabled:hover .ant-pagination-item-link {
  color: #9CA3AF !important;
}
/* Arrow buttons */
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  color: #374151 !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
  -webkit-box-pack: center !important;
      -ms-flex-pack: center !important;
          justify-content: center !important;
  font-size: 0.75rem !important;
}
.ant-pagination-prev:hover .ant-pagination-item-link,
.ant-pagination-next:hover .ant-pagination-item-link {
  color: #7D48B0 !important;
}
/* Jump indicators */
.ant-pagination-jump-prev .ant-pagination-item-link-icon,
.ant-pagination-jump-next .ant-pagination-item-link-icon {
  color: #7D48B0 !important;
}
/* Remove default focus outline and add custom one */
.ant-pagination-item:focus-visible,
.ant-pagination-prev:focus-visible,
.ant-pagination-next:focus-visible {
  outline: none !important;
  -webkit-box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1) !important;
          box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1) !important;
}
/* Page size dropdown menu */
.ant-select-dropdown {
  border-radius: 0.5rem !important;
  border: 1px solid #E2E8F1 !important;
  -webkit-box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1) !important;
          box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1) !important;
}
.ant-select-item {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  color: #374151 !important;
  padding: 0.5rem 0.75rem !important;
  -webkit-transition: all 0.2s ease !important;
  transition: all 0.2s ease !important;
}
.ant-select-item-option-selected {
  background: #F7EFFF !important;
  color: #7D48B0 !important;
  font-weight: 600 !important;
}
.ant-select-item-option-active {
  background: #F7EFFF !important;
}
/* Mobile responsiveness */
@media (max-width: 768px) {
  .ant-pagination {
    -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    gap: 0.75rem !important;
  }

  .ant-pagination-total-text {
    width: 100% !important;
    -webkit-box-ordinal-group: 0 !important;
        -ms-flex-order: -1 !important;
            order: -1 !important;
    margin-bottom: 0.5rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./custom-app.css"],"names":[],"mappings":"AAAA;;;;6CAI6C;AAC7C;EACE,eAAe,EAAE,2CAA2C;AAC9D;AAEA;EACE;IACE,eAAe,EAAE,6CAA6C;EAChE;AACF;AAEA;EACE;IACE,eAAe,EAAE,4CAA4C;EAC/D;AACF;AAEA;EACE;IACE,eAAe,EAAE,6CAA6C;EAChE;AACF;AAEA;EACE;IACE,eAAe,EAAE,0CAA0C;EAC7D;AACF;AAEA;;6CAE6C;AAC7C;EACE,UAAU;EACV,4BAA4B;EAC5B,gBAAgB;AAClB;AAEA,wFAAwF;AACxF;EACE,aAAa;AACf;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,gBAAgB;AAClB;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;AAEA,sCAAsC;AACtC;EACE,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AAEA;EACE,UAAU;AACZ;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,uBAAkB;EAAlB,0BAAkB;EAAlB,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,iCAAyB;EAAzB,yBAAyB;AAC3B;AAEA;EACE,sBAAsB;EACtB,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,iCAAyB;EAAzB,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,cAAc;AAChB;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;AAEA,oEAAoE;AACpE;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;AAC9B;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AAEA;EACE,UAAU;AACZ;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AAEA,qDAAqD;AACrD;;;;EAIE,oBAAoB;AACtB;AAEA,uCAAuC;AACvC;EACE,0BAA0B;AAC5B;AAEA,gCAAgC;AAChC;EACE,8BAA8B;AAChC;AAEA;EACE,cAAc;AAChB;AAEA,2BAA2B;AAE3B,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,+DAAuD;UAAvD,uDAAuD;EACvD,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iCAAyB;EAAzB,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iCAAyB;EAAzB,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,aAAa;AACf;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AAEA,kCAAkC;AAClC;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;AAEA;yEACyE;AACzE;EACE,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;AAEA;;8EAE8E;AAC9E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB;6EAC2E;EAC3E,qBAAiB;MAAjB,iBAAiB;AACnB;AAEA;EACE;6EAC2E;EAC3E,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;AACd;AAEA,4EAA4E;AAC5E;EACE,2BAA2B;EAC3B,mBAAe;MAAf,eAAe;AACjB;AAEA,8EAA8E;AAC9E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;EACX,oBAAc;MAAd,cAAc;EACd,mBAAe;MAAf,eAAe;EACf,iBAAiB;EACjB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA,8EAA8E;AAC9E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,YAAY;EACZ,wBAAwB;AAC1B;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;AACxB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,uBAAuB;AACzB;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kCAAiC;UAAjC,iCAAiC;AACnC;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,oBAAoB;AACtB;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kCAAiC;UAAjC,iCAAiC;AACnC;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,oDAA4C;UAA5C,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;AAClB;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,kCAAkC;EAClC,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;AAChC;AAEA;EACE,wBAAwB;AAC1B;AAEA,iCAAiC;AACjC;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,iCAAiC;AACnC;AAEA,2DAA2D;AAC3D;;EAEE,2BAA2B;AAC7B;AAEA,kDAAkD;AAClD;EACE,8BAA8B;EAC9B,0CAA0C;AAC5C;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;AAC5C;AAEA,6DAA6D;AAC7D;EACE,0CAA0C;AAC5C;AAEA,0DAA0D;AAC1D;EACE,8BAA8B;AAChC;AAEA,yEAAyE;AACzE;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,qBAAqB;AACvB;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,qBAAqB;AACvB;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AAEA,4EAA4E;AAC5E;EACE,oEAA4D;UAA5D,4DAA4D;AAC9D;AAEA,kFAAkF;AAClF;;EAEE,oEAA4D;UAA5D,4DAA4D;AAC9D;AAEA;;6CAE6C;AAE7C,yBAAyB;AACzB;EACE,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,oCAA8B;MAA9B,iCAA8B;UAA9B,8BAA8B;EAC9B,oCAAyC;MAAzC,iCAAyC;UAAzC,yCAAyC;EACzC,4BAA4B;EAC5B,8BAA8B;EAC9B,6CAA6C;EAC7C,oCAAoC;EACpC,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;AAC3C;AAEA,qBAAqB;AACrB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,uCAAoB;MAApB,6BAAoB;UAApB,oBAAoB;EACpB,6BAA6B;AAC/B;AAEA,uBAAuB;AACvB;EACE,uCAAmB;MAAnB,4BAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,+BAA+B;AACjC;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;EACnC,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,4CAAoC;EAApC,oCAAoC;AACtC;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AAEA;EACE,gCAAgC;EAChC,sEAA8D;UAA9D,8DAA8D;AAChE;AAEA,+BAA+B;AAC/B;;;;;EAKE,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,4CAAoC;EAApC,oCAAoC;AACtC;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAAsC;EAAtC,sCAAsC;AACxC;AAEA,gBAAgB;AAChB;;;EAGE,gCAAgC;EAChC,8BAA8B;AAChC;AAEA;EACE,yBAAyB;AAC3B;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AAEA;EACE,yBAAyB;AAC3B;AAEA,mBAAmB;AACnB;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;AAChC;AAEA;;EAEE,yBAAyB;AAC3B;AAEA,kBAAkB;AAClB;;EAEE,yBAAyB;EACzB,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,oCAA8B;MAA9B,iCAA8B;UAA9B,8BAA8B;EAC9B,mCAAkC;MAAlC,gCAAkC;UAAlC,kCAAkC;EAClC,6BAA6B;AAC/B;AAEA;;EAEE,yBAAyB;AAC3B;AAEA,oBAAoB;AACpB;;EAEE,yBAAyB;AAC3B;AAEA,oDAAoD;AACpD;;;EAGE,wBAAwB;EACxB,sEAA8D;UAA9D,8DAA8D;AAChE;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,oCAAoC;EACpC,mEAA2D;UAA3D,2DAA2D;AAC7D;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;EAClC,4CAAoC;EAApC,oCAAoC;AACtC;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;AAEA;EACE,8BAA8B;AAChC;AAEA,0BAA0B;AAC1B;EACE;IACE,8BAA0B;QAA1B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uCAAoB;QAApB,6BAAoB;YAApB,oBAAoB;IACpB,gCAAgC;EAClC;AACF","sourcesContent":["/* ========================================\r\n   Global Responsive Rem Scaling\r\n   All rem-based measurements will scale proportionally\r\n   based on screen size for consistent responsive design\r\n   ======================================== */\r\nhtml {\r\n  font-size: 16px; /* Default: 1rem = 16px for large screens */\r\n}\r\n\r\n@media (max-width: 1400px) {\r\n  html {\r\n    font-size: 15px; /* 1rem = 15px, scales everything to 93.75% */\r\n  }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  html {\r\n    font-size: 14px; /* 1rem = 14px, scales everything to 87.5% */\r\n  }\r\n}\r\n\r\n@media (max-width: 968px) {\r\n  html {\r\n    font-size: 13px; /* 1rem = 13px, scales everything to 81.25% */\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  html {\r\n    font-size: 12px; /* 1rem = 12px, scales everything to 75% */\r\n  }\r\n}\r\n\r\n/* ========================================\r\n   Layout Body Styles\r\n   ======================================== */\r\n.custom-body {\r\n  padding: 0;\r\n  height: calc(100vh - 3.5rem);\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Focus mode hides the global app header — give .custom-body the full viewport height */\r\nbody.report-focus-mode .custom-body {\r\n  height: 100vh;\r\n}\r\n\r\n.viewer-body {\r\n  /* padding: 0 0.75rem; */\r\n  /* height: calc(100% - 60px); */\r\n  overflow-y: auto;\r\n}\r\n\r\n.login-body {\r\n  padding: 0;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.no-auth-body {\r\n  padding: 0;\r\n  height: 100vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Pill-style segmented control tabs */\r\n.ant-tabs-nav {\r\n  margin: 0;\r\n  padding: 1rem 1.25rem;\r\n  background: #F5F7FD;\r\n  border-bottom: none;\r\n}\r\n\r\n.ant-tabs-nav-wrap {\r\n  padding: 0;\r\n}\r\n\r\n.ant-tabs-nav-list {\r\n  background: #FFFFFF;\r\n  border-radius: 0.625rem;\r\n  padding: 0.25rem;\r\n  gap: 0.625rem;\r\n  display: flex;\r\n  width: fit-content;\r\n  height: 2.5rem;\r\n}\r\n\r\n.ant-tabs-tab {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  height: 2rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.ant-tabs-tab-btn {\r\n  padding: 0.375rem 1rem;\r\n  font-family: 'Inter Variable', Inter, sans-serif;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0.04px;\r\n  color: #000000;\r\n  background: #FFFFFF;\r\n  border-radius: 0.5rem;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 2rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Inactive tab hover state */\r\n.ant-tabs-tab:not(.ant-tabs-tab-active):hover .ant-tabs-tab-btn {\r\n  background: #e8e8e8;\r\n  color: #333333;\r\n}\r\n\r\n/* Active tab state */\r\n.ant-tabs-tab.ant-tabs-tab-active {\r\n  background: transparent;\r\n}\r\n\r\n/* Use higher specificity to override Ant Design's internal styles */\r\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\r\n  background: var(--primary-color) !important;\r\n  color: #ffffff !important;\r\n  font-weight: 600;\r\n  text-shadow: none !important;\r\n}\r\n\r\n/* Hide the default ink bar */\r\n.ant-tabs-ink-bar {\r\n  display: none;\r\n}\r\n\r\n/* Content styling */\r\n.ant-tabs-content-holder {\r\n  background: #F5F7FD;\r\n}\r\n\r\n.ant-tabs-tabpane {\r\n  padding: 0;\r\n}\r\n\r\n/* Remove default Ant Design tab borders and spacing */\r\n.ant-tabs > .ant-tabs-nav {\r\n  border-bottom: none;\r\n  background: #F5F7FD;\r\n}\r\n\r\n/* Override Ant Design's default 16px bottom margin */\r\n.ant-tabs-top > .ant-tabs-nav,\r\n.ant-tabs-bottom > .ant-tabs-nav,\r\n.ant-tabs-top > div > .ant-tabs-nav,\r\n.ant-tabs-bottom > div > .ant-tabs-nav {\r\n  margin: 0 !important;\r\n}\r\n\r\n/* Remove default icon margin in tabs */\r\n.ant-tabs .ant-tabs-tab .anticon:not(:last-child) {\r\n  margin-right: 0 !important;\r\n}\r\n\r\n/* Icon styling in tab buttons */\r\n.ant-tabs-tab-btn .anticon {\r\n  font-weight: normal !important;\r\n}\r\n\r\n.ant-tabs-tab + .ant-tabs-tab {\r\n  margin-left: 0;\r\n}\r\n\r\n/* Reusable Button Styles */\r\n\r\n/* Secondary Button Style */\r\n.btn-secondary {\r\n  padding: 0.375rem 0.625rem;\r\n  height: 2.25rem;\r\n  background: #FFFFFF;\r\n  border: 1px solid #EAEEF2;\r\n  box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;\r\n  border-radius: 0.375rem;\r\n  font-family: Inter, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0.04px;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #f8f9fa;\r\n  border-color: #d1d5db;\r\n}\r\n\r\n/* Primary Button Style */\r\n.btn-primary {\r\n  padding: 0.375rem 0.625rem;\r\n  height: 2.25rem;\r\n  background: #7D48B0;\r\n  border: 1px solid #7D48B0;\r\n  border-radius: 0.375rem;\r\n  font-family: 'Inter Variable', Inter, sans-serif;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0.04px;\r\n  color: #FFFFFF;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.375rem;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #6a3d96;\r\n  border-color: #6a3d96;\r\n}\r\n\r\n/* Primary Button Disabled State */\r\n.btn-primary:disabled,\r\n.btn-primary[disabled] {\r\n  background: #E5E7EB;\r\n  border-color: #E5E7EB;\r\n  color: #9CA3AF;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.btn-primary:disabled:hover,\r\n.btn-primary[disabled]:hover {\r\n  background: #E5E7EB;\r\n  border-color: #E5E7EB;\r\n  color: #9CA3AF;\r\n}\r\n\r\n.btn-primary .anticon {\r\n  font-size: 1rem;\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n/* Compact variant — used when buttons share a line with filters/toolbars.\r\n   Height matches the 30px \"Saved views\" pill so the row stays aligned. */\r\n.btn-compact {\r\n  height: 1.875rem;\r\n  padding: 0.25rem 0.75rem;\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n/* Filters toolbar — keeps quick filters / grid on one side and the action\r\n   buttons on the other, on a single line. Shared by Orders, My worklist and\r\n   QC Workstation so the filter actions no longer need a dedicated tall row. */\r\n.filter-toolbar {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.5rem 1rem;\r\n  margin-bottom: 1rem;\r\n  /* Keep the chip column and the action column side-by-side; chips wrap inside\r\n     their own column rather than pushing the action buttons to a new line. */\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.filter-toolbar-main {\r\n  /* Take only the space left of the action buttons, and allow shrinking so the\r\n     chips wrap within this column instead of overflowing into the actions. */\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n/* Shortcut chips wrap onto multiple lines instead of overflowing the row. */\r\n.filter-toolbar-main > div {\r\n  margin-bottom: 0 !important;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Action buttons keep their width and stay right-aligned on the first line. */\r\n.filter-toolbar-actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex-shrink: 0;\r\n  flex-wrap: wrap;\r\n  margin-left: auto;\r\n  align-items: center;\r\n}\r\n\r\n/* ===== Filter layout — 70 / 30 split (inputs left, modalities right) ===== */\r\n.filter-layout {\r\n  display: flex;\r\n  gap: 1rem;\r\n  align-items: flex-start;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.filter-layout-inputs {\r\n  flex: 7;\r\n  min-width: 0;\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.filter-layout-modalities {\r\n  flex: 3;\r\n  min-width: 0;\r\n  border-left: 1px solid #E2E8F1;\r\n  padding-left: 0.875rem;\r\n}\r\n\r\n.filter-modalities-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 0.375rem;\r\n}\r\n\r\n.filter-modalities-label {\r\n  font-size: 0.6875rem;\r\n  font-weight: 600;\r\n  color: #9CA3AF;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.filter-modalities-selectall.ant-checkbox-wrapper {\r\n  font-size: 0.6875rem;\r\n  font-weight: 600;\r\n  color: #9CA3AF;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  margin-inline-start: 0 !important;\r\n}\r\n\r\n.filter-layout-modalities .ant-checkbox-group {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.25rem 0.75rem;\r\n}\r\n\r\n.filter-layout-modalities .ant-checkbox-wrapper {\r\n  font-size: 0.8125rem;\r\n  color: #374151;\r\n  margin-inline-start: 0 !important;\r\n}\r\n\r\n/* Global Table Styling */\r\n.ant-table-wrapper {\r\n  border: 1px solid #E2E8F1;\r\n  box-shadow: 0rem 0rem 1.25rem 0rem #12344D40;\r\n  border-radius: 0.5rem;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Global Table Header Styling */\r\n.ant-table-thead > tr > th {\r\n  height: 2.5rem !important;\r\n  padding: 0.5rem 0.75rem !important;\r\n  font-family: Inter, sans-serif !important;\r\n  font-weight: 600 !important;\r\n  font-size: 0.75rem !important;\r\n  line-height: 1.25rem !important;\r\n  letter-spacing: 0.06px !important;\r\n  border-bottom: none !important;\r\n}\r\n\r\n.ant-table-thead > tr > th::before {\r\n  display: none !important;\r\n}\r\n\r\n/* Global Table Cell Typography */\r\n.ant-table-tbody > tr > td {\r\n  font-family: Inter, sans-serif !important;\r\n  font-weight: 400 !important;\r\n  font-size: 0.875rem !important;\r\n  line-height: 1rem !important;\r\n  letter-spacing: 0.04px !important;\r\n}\r\n\r\n/* Bold styling for clickable elements like patient names */\r\n.ant-table-tbody > tr > td .col-pat-name,\r\n.ant-table-tbody > tr > td .ant-btn-link {\r\n  font-weight: 600 !important;\r\n}\r\n\r\n/* Global Table Row Styling - Alternating Colors */\r\n.ant-table-tbody > tr:nth-child(odd) > td {\r\n  background: #F8F5FB !important;\r\n  border-right: 1px solid #EAEEF2 !important;\r\n}\r\n\r\n.ant-table-tbody > tr:nth-child(even) > td {\r\n  background: #FFFFFF !important;\r\n  border-right: 1px solid #EAEEF2 !important;\r\n}\r\n\r\n/* Remove the default Ant Design striped styling if present */\r\n.ant-table-tbody > tr.ant-table-row:hover > td {\r\n  background: rgba(0, 0, 0, 0.04) !important;\r\n}\r\n\r\n/* Ensure selected rows maintain their selection styling */\r\n.ant-table-tbody > tr.ant-table-row-selected > td {\r\n  background: #e6f7ff !important;\r\n}\r\n\r\n/* Sticky Column Fix - Remove transparency and ensure proper background */\r\n.ant-table-tbody > tr:nth-child(odd) > td.ant-table-cell-fix-right {\r\n  background: #F8F5FB !important;\r\n  border-right: 1px solid #EAEEF2 !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.ant-table-tbody > tr:nth-child(even) > td.ant-table-cell-fix-right {\r\n  background: #FFFFFF !important;\r\n  border-right: 1px solid #EAEEF2 !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n/* Sticky header cells */\r\n.ant-table-thead > tr > th.ant-table-cell-fix-right {\r\n  opacity: 1 !important;\r\n  z-index: 3 !important;\r\n}\r\n\r\n/* Add shadow only to the first sticky column for better visual separation */\r\n.first-sticky-column {\r\n  box-shadow: -0.125rem 0 0.5rem rgba(0, 0, 0, 0.1) !important;\r\n}\r\n\r\n/* Ensure shadow is applied to both header and body cells of first sticky column */\r\n.ant-table-thead .first-sticky-column,\r\n.ant-table-tbody .first-sticky-column {\r\n  box-shadow: -0.125rem 0 0.5rem rgba(0, 0, 0, 0.1) !important;\r\n}\r\n\r\n/* ========================================\r\n   Custom Pagination Styling\r\n   ======================================== */\r\n\r\n/* Pagination container */\r\n.ant-pagination {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: space-between !important;\r\n  padding: 4px 1rem !important;\r\n  background: #FFFFFF !important;\r\n  border-radius: 0 0 0.75rem 0.75rem !important;\r\n  border: 1px solid #E2E8F1 !important;\r\n  border-top: none !important;\r\n  margin: 0 !important;\r\n  font-family: Inter, sans-serif !important;\r\n}\r\n\r\n/* Total items text */\r\n.ant-pagination-total-text {\r\n  font-size: 0.875rem !important;\r\n  font-weight: 500 !important;\r\n  color: #374151 !important;\r\n  order: -1 !important;\r\n  margin-right: auto !important;\r\n}\r\n\r\n/* Page size selector */\r\n.ant-pagination-options {\r\n  order: 2 !important;\r\n}\r\n\r\n.ant-pagination .ant-select {\r\n  margin-right: 0.5rem !important;\r\n}\r\n\r\n.ant-pagination .ant-select-selector {\r\n  border: 1px solid #D1D5DB !important;\r\n  border-radius: 0.5rem !important;\r\n  padding: 0.25rem 0.75rem !important;\r\n  height: 2rem !important;\r\n  font-size: 0.875rem !important;\r\n  font-weight: 500 !important;\r\n  color: #374151 !important;\r\n  background: #FFFFFF !important;\r\n  transition: all 0.2s ease !important;\r\n}\r\n\r\n.ant-pagination .ant-select-selector:hover {\r\n  border-color: #7D48B0 !important;\r\n  background: #F9FAFB !important;\r\n}\r\n\r\n.ant-pagination .ant-select-focused .ant-select-selector {\r\n  border-color: #7D48B0 !important;\r\n  box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1) !important;\r\n}\r\n\r\n/* Pagination items container */\r\n.ant-pagination-item,\r\n.ant-pagination-prev,\r\n.ant-pagination-next,\r\n.ant-pagination-jump-prev,\r\n.ant-pagination-jump-next {\r\n  border: 1px solid #D1D5DB !important;\r\n  border-radius: 0.5rem !important;\r\n  background: #FFFFFF !important;\r\n  min-width: 2rem !important;\r\n  height: 2rem !important;\r\n  line-height: 1.875rem !important;\r\n  font-size: 0.875rem !important;\r\n  font-weight: 500 !important;\r\n  margin: 0 0.25rem !important;\r\n  transition: all 0.2s ease !important;\r\n}\r\n\r\n/* Pagination item text */\r\n.ant-pagination-item a {\r\n  color: #374151 !important;\r\n  font-weight: 500 !important;\r\n  transition: color 0.2s ease !important;\r\n}\r\n\r\n/* Hover state */\r\n.ant-pagination-item:hover,\r\n.ant-pagination-prev:hover,\r\n.ant-pagination-next:hover {\r\n  border-color: #7D48B0 !important;\r\n  background: #F7EFFF !important;\r\n}\r\n\r\n.ant-pagination-item:hover a {\r\n  color: #7D48B0 !important;\r\n}\r\n\r\n/* Active page */\r\n.ant-pagination-item-active {\r\n  background: #7D48B0 !important;\r\n  border-color: #7D48B0 !important;\r\n}\r\n\r\n.ant-pagination-item-active a {\r\n  color: #FFFFFF !important;\r\n}\r\n\r\n.ant-pagination-item-active:hover {\r\n  background: #7D48B0 !important;\r\n  border-color: #7D48B0 !important;\r\n}\r\n\r\n.ant-pagination-item-active:hover a {\r\n  color: #FFFFFF !important;\r\n}\r\n\r\n/* Disabled state */\r\n.ant-pagination-disabled,\r\n.ant-pagination-disabled:hover {\r\n  border-color: #E5E7EB !important;\r\n  background: #F9FAFB !important;\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.ant-pagination-disabled .ant-pagination-item-link,\r\n.ant-pagination-disabled:hover .ant-pagination-item-link {\r\n  color: #9CA3AF !important;\r\n}\r\n\r\n/* Arrow buttons */\r\n.ant-pagination-prev .ant-pagination-item-link,\r\n.ant-pagination-next .ant-pagination-item-link {\r\n  color: #374151 !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  font-size: 0.75rem !important;\r\n}\r\n\r\n.ant-pagination-prev:hover .ant-pagination-item-link,\r\n.ant-pagination-next:hover .ant-pagination-item-link {\r\n  color: #7D48B0 !important;\r\n}\r\n\r\n/* Jump indicators */\r\n.ant-pagination-jump-prev .ant-pagination-item-link-icon,\r\n.ant-pagination-jump-next .ant-pagination-item-link-icon {\r\n  color: #7D48B0 !important;\r\n}\r\n\r\n/* Remove default focus outline and add custom one */\r\n.ant-pagination-item:focus-visible,\r\n.ant-pagination-prev:focus-visible,\r\n.ant-pagination-next:focus-visible {\r\n  outline: none !important;\r\n  box-shadow: 0 0 0 0.1875rem rgba(125, 72, 176, 0.1) !important;\r\n}\r\n\r\n/* Page size dropdown menu */\r\n.ant-select-dropdown {\r\n  border-radius: 0.5rem !important;\r\n  border: 1px solid #E2E8F1 !important;\r\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1) !important;\r\n}\r\n\r\n.ant-select-item {\r\n  font-size: 0.875rem !important;\r\n  font-weight: 500 !important;\r\n  color: #374151 !important;\r\n  padding: 0.5rem 0.75rem !important;\r\n  transition: all 0.2s ease !important;\r\n}\r\n\r\n.ant-select-item-option-selected {\r\n  background: #F7EFFF !important;\r\n  color: #7D48B0 !important;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.ant-select-item-option-active {\r\n  background: #F7EFFF !important;\r\n}\r\n\r\n/* Mobile responsiveness */\r\n@media (max-width: 768px) {\r\n  .ant-pagination {\r\n    flex-wrap: wrap !important;\r\n    gap: 0.75rem !important;\r\n  }\r\n\r\n  .ant-pagination-total-text {\r\n    width: 100% !important;\r\n    order: -1 !important;\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
